module.exports = __webpack_public_path__ + "static/media/ic_email.e1af47f7.svg";